import { Dispatch, SetStateAction, useState } from 'react';

type TUseBoolean = (
  initialValue?: boolean
) => [boolean, Dispatch<SetStateAction<boolean>>, () => void];

export const useBoolean: TUseBoolean = (initialValue = true) => {
  const [booleanMode, setBooleanMode] = useState(initialValue);

  const onToggleBooleanMode = () => setBooleanMode(!booleanMode);

  return [booleanMode, setBooleanMode, onToggleBooleanMode];
};
